/**
 * Преобразовать дату к виду DD.MM.YY
 *
 * @param {Number} timestamp
 * @return {String}
 */
export function getFormattedDate(timestamp) {
  if (!timestamp) return null;

  return new Intl.DateTimeFormat("ru", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  }).format(timestamp);
}
